import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import type {
  MeetBackground,
  MeetBackgroundSettings,
} from "./meet-background.interface";

@Injectable({
  providedIn: "root",
})
export class MeetBackgroundService {
  constructor(private http: HttpClient) {}

  getAll(): Observable<{ meetBackgrounds: MeetBackground[] }> {
    return this.http.get<{ meetBackgrounds: MeetBackground[] }>(
      "/backgrounds/meets",
    );
  }

  getOne(meetBackgroundId: string): Observable<MeetBackground> {
    return this.http.get<MeetBackground>(
      `/backgrounds/meets/${encodeURIComponent(meetBackgroundId)}`,
    );
  }

  create(payload: {
    name: string;
    isDefault?: boolean;
    digitalCardProfileId?: string | null;
    settings: MeetBackgroundSettings;
  }): Observable<MeetBackground> {
    return this.http.post<MeetBackground>("/backgrounds/meets", payload);
  }

  update(
    meetBackgroundId: string,
    payload: {
      name: string;
      isDefault?: boolean;
      digitalCardProfileId?: string | null;
      settings: MeetBackgroundSettings;
    },
  ): Observable<MeetBackground> {
    return this.http.put<MeetBackground>(
      `/backgrounds/meets/${encodeURIComponent(meetBackgroundId)}`,
      payload,
    );
  }

  setDefault(meetBackgroundId: string): Observable<MeetBackground> {
    return this.http.put<MeetBackground>(
      `/backgrounds/meets/${encodeURIComponent(meetBackgroundId)}/default`,
      {},
    );
  }

  remove(meetBackgroundId: string): Observable<void> {
    return this.http.delete<void>(
      `/backgrounds/meets/${encodeURIComponent(meetBackgroundId)}`,
    );
  }

  getPreviewQrTarget(
    digitalCardProfileId?: string | null,
  ): Observable<{ qrTarget: string }> {
    let params = new HttpParams();
    const profileId = (digitalCardProfileId ?? "").trim();
    if (profileId) {
      params = params.set("digitalCardProfileId", profileId);
    }
    return this.http.get<{ qrTarget: string }>("/backgrounds/meets/qr-target", {
      params,
    });
  }
}
